// src/reducers/groomersReducer.js

import { createListReducer } from './createListReducer';
  
  export const initialState = {
    groomers: [],
    loading: false,
    error: "",
    order: "asc",
    orderBy: "firstName",
    page: 0,
    rowsPerPage: 25,
    totalGroomers: 0,
  };
  
  export const groomersReducer = createListReducer('groomers', 'totalGroomers');